// removed by extract-text-webpack-plugin
module.exports = {"electro":"_390oNYNnHTK0cHRbKiXCik","tg":"_2ZXlweqF02qKB0BESKDncw","tgF6ar":"KrTpLpyHTX10WThzxC3DC","value":"_3yEO-m6eImxidCNj9L_r5Z","disabled":"Y0esYBm2LYh0RZXLZViXj"};


//////////////////
// WEBPACK FOOTER
// ./src/components/entries/Electrotable/style.css
// module id = 338
// module chunks = 0